<template>
    <div class="account-container m-xl-0">

        <div class="btn-container btn-container--start mb-3" v-if="!isLoading && bookings.length && bookings.length > 6">
            <a href="/booking/" class="btn btn--slate-blue">
                Make a booking
            </a>
        </div>

        <h2>Your Bookings</h2>

        <div v-if="isLoading" class="d-flex justify-content-center">
            <loader></loader>
        </div>

        <div v-else-if="!isLoading && bookings.length ">

            <div class="row">
                <div class="col-24">
                    <ul class="booking-type d-flex flex-row">

                        <li class="mx-2" style="margin-left:0">
                            <router-link v-bind:to="{name : 'account_stay_bookings'}">
                                Stay
                            </router-link>


                        </li>

                        <li class="mx-2">
                            <router-link v-bind:to="{name : 'account_spa_bookings'}">
                                Spa
                            </router-link>

                        </li>

                    </ul>
                </div>
            </div>

            <div class="row" v-if="futureBookings != null && futureBookings.length">
                <h3>Upcoming Bookings</h3>


                <div class="col-24 ">
                    <div class="row">
                        <div class="col-24">
                            <div class="mb-4">
                                <div v-for="(booking, index) in futureBookings"
                                     v-bind:key="index"
                                     class="mb-4">
                                    <account-spa-booking-panel v-bind:booking="booking"></account-spa-booking-panel>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>



            <div class="row" v-if="previousBookings != null && previousBookings.length">
                <h3>Previous Bookings</h3>

                <div class="col-24 ">
                    <div class="row">
                        <div class="col-24">
                            <div v-for="(booking, index) in previousBookings"
                                 v-bind:key="index"
                                 class="mb-4">
                                <account-spa-booking-panel v-bind:booking="booking"></account-spa-booking-panel>

                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="btn-container btn-container--start">
                <a href="/booking/" class="btn btn--slate-blue">
                    Make a booking
                </a>
            </div>
        </div>
        <div v-else>
            <p>You currently have no bookings.</p>
            <div class="btn-container btn-container--start">
                <a href="/booking/" class="btn btn--slate-blue">
                    Make a booking
                </a>
            </div>
        </div>
    </div>

</template>

<script>
    import AccountSpaBookingPanel from '../components/AccountSpaBookingPanel.vue';
    import Loader from '@/shared/components/Loader.vue';

    import { accountStore } from '../store/index';

    import spaapi from '@/shared/api/spa';

    export default {
        name: 'AccountSpaBookings',

        created() {
            var so = this;
            so.isLoading = true;

            if (this.configuration == null) {
                accountStore.dispatch("getConfiguration");
            }

   


            spaapi.fetchBookings(t => {
                so.bookings = t;
                so.isLoading = false;

            }, t => {
                so.isLoading = false;
            })

        },
        components: {
            AccountSpaBookingPanel,
            Loader
        },
        computed: {
            configuration() {
                return accountStore.getters.accountConfiguration;
            },
            futureBookings() {
                if (this.bookings != null) {

                    return this.bookings.filter(item => -item.DaysToGo >= 0);
                }
                return null;
            },
            previousBookings() {
                if (this.bookings != null) {

                    return this.bookings.filter(item => -item.DaysToGo < 0);
                }
                return null;
            }
        },
        data() {
            return {
                isLoading: false,
                bookings: [],
     
            }
        }
    }
</script>

<style>
    .booking-type{
        list-style: none;
        padding: 0;
        margin: 0;
        margin-bottom: 30px;
        }

        .booking-type li {
            padding: 10px;
            border: solid 2px black;
            display: inline-block;
            font-size: 14px;
            text-transform: uppercase;
            font-weight: bold;
        }

</style>